import { Button, Input } from 'ui'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'
import { IconTrash } from '@tabler/icons-react'
import { IconPlus } from '@tabler/icons-react'
import { nanoid } from 'nanoid'

export const FieldAttributeOptions: FieldAttributesSignature = ({ field }) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Opciones</label>
      <div className='flex flex-col space-y-2'>
        {(field.options || []).map((option, index) => {
          return (
            <div
              className='flex flex-row space-x-2 items-center'
              key={option.id!}
            >
              <Input
                size='sm'
                defaultValue={option.value}
                onChange={(e) =>
                  updateField(field.id, {
                    options: (field.options || []).map((opt, iterIndex) => {
                      if (opt.id !== option.id) return opt

                      return {
                        ...opt,
                        value: e.target.value,
                      }
                    }),
                  })
                }
              />
              {index === 0 ? (
                <Button
                  onClick={() => {
                    updateField(field.id, {
                      options: [
                        ...(field.options || []),
                        {
                          value: 'Opción ' + ((field.options || []).length + 1),
                          id: nanoid(),
                        },
                      ],
                    })
                  }}
                  variant={'ghost'}
                  size='sm'
                >
                  <IconPlus className='w-4 h-4 text-primary' />
                </Button>
              ) : (
                <Button
                  size='sm'
                  onClick={() => {
                    updateField(field.id, {
                      options: (field.options || []).filter(
                        (opt) => opt.id !== option.id
                      ),
                    })
                  }}
                  variant={'ghost'}
                >
                  <IconTrash className='w-4 h-4' />
                </Button>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
